const paymentMethods = [
    { value: "cash", label: "Cash" },
    { value: "creditCard", label: "Credit Card" },
    { value: "annulment", label: "Annulment", restricted: true },
    { value: "zelle", label: "Zelle" },
    { value: "stripe", label: "Stripe - Client Portal" },
];

export default paymentMethods;
